module.exports = __webpack_public_path__ + "static/media/LadderAgainstWall.a60d2f17.jpg";